import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { useNavigate } from "react-router-dom";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";

export const DeleteScheduleDialog = ({
  scheduleId,
  scheduleName,
}: {
  scheduleId: string;
  scheduleName: string;
}) => {
  const navigate = useNavigate();

  const {
    deleteScheduleDialogOpen,
    setDeleteScheduleDialogOpen,
    handleDeleteSchedule,
  } = useSiteAboutStore();

  return (
    <Dialog
      open={deleteScheduleDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {` Are you sure you want to delete ${scheduleName} ?`}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Once deleted this action can&apos;t be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDeleteScheduleDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setDeleteScheduleDialogOpen(false);
            handleDeleteSchedule(scheduleId, navigate);
          }}
          text="Delete"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
